import {Component, 
	OnInit, 
	ElementRef, 
	ViewChild, 
	ChangeDetectionStrategy, 
	ChangeDetectorRef, 
    Inject} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
// Material
import { MatPaginator, MatSort, MatDialog, MatTableDataSource, MatMenuTrigger, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { SelectionModel } from '@angular/cdk/collections';
import { CdkDragStart, CdkDropList, moveItemInArray } from '@angular/cdk/drag-drop';
// RXJS
import { tap } from 'rxjs/operators';
import { merge, BehaviorSubject } from 'rxjs';
//Service
import { SubheaderService } from '../../../../../../../core/_base/layout';
import { LayoutUtilsService, QueryParamsModel, MessageType } from '../../../../../../../core/_base/crud';
import { environment } from '../../../../../../../../environments/environment';
import { DeNghiMuaHangPageService } from '../de-nghi-mua-hang-page-service/de-nghi-mua-hang-page.service';
//Model
import { CommonConFig } from 'app/views/pages/nfc/dung-chung/__model/common_config.model';
import { FunctionPublic } from '../../../../dung-chung/__function/common_function';

@Component({
	selector: 'm-lich-su-mua-hang-list-dialog',
	templateUrl: './lich-su-mua-hang-list-dialog.component.html',
	styleUrls: ['../de-nghi-mua-hang-page.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers:[DatePipe]
})

export class LichSuMuaHangDialogComponent implements OnInit{

	/*----------------------------Config Form ---------------------------*/
	CONFIG: CommonConFig;
	/* ------------------------------------------------------------------*/

  	/*--------------------Comment columns mat-table----------------------*/
    displayedColumns = [];
	availableColumns = [
        {
			stt: 1,
			name: '#',
			displayName: '#',
			alwaysChecked: false,
			isShow: true
        },
        {
            stt: 2,
            name: 'SLMua',
            displayName: 'SL mua',
            alwaysChecked: false,
			isShow: true
        },
		{
            stt: 3,
            name: 'TenDVT',
            displayName: 'ĐVT',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 4,
            name: 'NgayLap',
            displayName: 'Ngày đặt hàng',
            alwaysChecked: false,
			isShow: true
        },
		{
            stt: 5,
            name: 'SoPhieu',
            displayName: 'Số phiếu ĐHM',
            alwaysChecked: false,
			isShow: true
		}
	];
	dataSource: any[] = [];
	/* ------------------------------------------------------------------*/

    /* ------------------------------Selection ---------------------------*/
	selectedColumns = new SelectionModel<any>(true, this.availableColumns);
	/* ------------------------------------------------------------------*/

	/* --------------------------- Loading.... ---------------------------*/
	loadingSubject = new BehaviorSubject<boolean>(false);
	loading$ = this.loadingSubject.asObservable();
	viewLoading = false;
	/* ------------------------------------------------------------------*/

	/*------------------------- Extend field: ----------------------------*/
	previousIndex: number;
	fixedPoint = 2;
	MaHH: string = '';
	TenHH: string = '';
	/* ------------------------------------------------------------------*/
    
    constructor(
		public dialogRef: MatDialogRef<LichSuMuaHangDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any,
		private service: DeNghiMuaHangPageService,
		public dialog: MatDialog,
		private datePipe: DatePipe,
		private changeDetect: ChangeDetectorRef,
		private layoutUtilsService: LayoutUtilsService) {
			let user = JSON.parse(localStorage.getItem("UserInfo"));
			this.dialogRef.disableClose = true;
		}

    /*---------------------------- LOAD DATA --------------------------------*/
	ngOnInit() {
		
		this.CONFIG = new CommonConFig();
		let id = this.data.data;
		this.MaHH = this.data.MaHH;
		this.TenHH = this.data.TenHH;

		this.service.getLSMuaHang(id).subscribe(res =>{
			if(res.status == 1){
				this.dataSource = res.data;
				this.dataSource = [...this.dataSource]
				this.changeDetect.detectChanges();
			}
		})

		this.showColumnsInTable();
		this.applySelectedColumns();

		this.dialogRef.keydownEvents().subscribe(event => {
			if (event.key == "Escape") {
				this.back();
			}
			this.changeDetect.detectChanges();
		});

	}
	back(){ 
		this.dialogRef.close();
	}
    /* -----------------------------------------------------------------------*/
	
	
	/*-------------------- HÀM HỖ TRỢ FORMAT DẠNG SỐ -----------------------*/
	ValidateChangeNumberEvent(columnName:string, item:any, event: any) {
		var count = 0;
		for(let i = 0; i < event.target.value.length; i++){
			if(event.target.value[i] == '.'){
				count += 1;
			}
		}
		var regex = this.CONFIG.REGEX_SPECIAL_CHARACTER;
		var found = event.target.value.match(regex);
		if (found != null) {
			const message = 'Dữ liệu không gồm chữ hoặc kí tự đặc biệt';
			this.layoutUtilsService.showErorr(message);
			return false;;
		}
		if (count >= 2) {
			const message = 'Dữ liệu không thể có nhiều hơn 2 dấu .';
			this.layoutUtilsService.showErorr(message);
			return false;;
		}
		return true;
	}
	formatNumber(item: string) {
		if (item == '' || item == null || item == undefined) return '';
		if (typeof (item) === "string") {
			item = item.replace(/,/g, "");
		}
		return Number(Math.round(parseFloat(item + 'e' + this.fixedPoint)) + 'e-' + this.fixedPoint).toFixed(this.fixedPoint)
	}
	formatComparenumber(number: string){
		return +number.replace(/\./g, "").replace(/,/g, ".");;
	}
	f_currency(value: string): any {
		if (value == null || value == undefined || value == '') value = '0.00';
		let nbr = Number((value.substring(0,value.length - (this.fixedPoint + 1)) + '').replace(/,/g, ""));
		return (nbr + '').replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,") + value.substr(value.length - (this.fixedPoint + 1),(this.fixedPoint + 1));
	}
	f_currency_V2(value: string): any {
		if (value == null || value == undefined || value == '') return '';
		let nbr = Number((value + '').replace(/,/g, ""));
		return (nbr + '').replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
	}
	f_currency_VND(value: string): any {
		if (value == null || value == undefined) return '0,00';
		return new Intl.NumberFormat('de-DE',{ style: 'decimal', currency: 'VND', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(value));
	}
	f_number(item: any = "0.00"){
		return FunctionPublic.F_NUMBER(item);
	}
	/* -----------------------------------------------------------------------*/
    
    /*-------------------- HÀM HỖ TRỢ FORMAT DẠNG NGÀY -----------------------*/
    getFormatDate(v: string = '') {
        if (v != '' && v != undefined) {
            return v.includes('T') ? v.replace(/(\d{4})(-)(\d{2})(-)(\d{2})(T)(\d{2})(:)(\d{2})(:)(\d{2}).*$/g, "$5/$3/$1") : v.replace(/(\d{4})(-)(\d{2})(-)(\d{2})/g, "$5/$3/$1");
        }
        return '';
    }
    f_convertDate(p_Val: any) {
        if(p_Val == null || p_Val == undefined || p_Val == '') return '';
        let a = p_Val === "" ? new Date() : new Date(p_Val);
        return ("0" + (a.getDate())).slice(-2) + "/" + ("0" + (a.getMonth() + 1)).slice(-2) + "/" + a.getFullYear();
	}
	getFirstDay_LastDay(b_firstday) {
		var date = new Date(), y = date.getFullYear(), m = date.getMonth();
		var firstDay = new Date(y, m, 1);
		var lastDay = new Date(y, m + 1, 0);
		var curent = new Date();
		return b_firstday ? this.datePipe.transform(firstDay, 'dd/MM/yyyy') : this.datePipe.transform(curent, 'dd/MM/yyyy');
	}
    /* -----------------------------------------------------------------------*/

    /* ---------- HÀM HỖ TRỢ HIỂN THỊ CỘT TRÊN MENU VÀ CHECKBOX CHO ROW--------*/
	IsAllColumnsChecked() {
		const numSelected = this.selectedColumns.selected.length;
		const numRows = this.availableColumns.length;
		return numSelected === numRows;
	}
	CheckAllColumns() {
		if (this.IsAllColumnsChecked()) {
			this.availableColumns.forEach(row => { if (!row.alwaysChecked) this.selectedColumns.deselect(row); });
		} else {
			this.availableColumns.forEach(row => this.selectedColumns.select(row));
		}
	}
	menuChange(e: any, type: 0 | 1 = 0) {
		this.layoutUtilsService.menuSelectColumns_On_Off();
	}
    /*----------------------------------------------------------------------- */
    
    /*-------- CÁC HÀM HỖ TRỢ CHUYỂN CỘT VÀ HIỂN THỊ CỘT TRONG BẢNG ----------*/
	showColumnsInTable(){
        for(let i = 0; i < this.availableColumns.length; i++){
            if(this.availableColumns[i].isShow == false){
                this.selectedColumns.toggle(this.availableColumns[i]);
            }
        }
    }
    findIndexColumn(column: string){
        for( let i = 0; i < this.availableColumns.length; i++){
            if(this.availableColumns[i].name == column)
                return i;
        }
    }
    dragStarted(event: CdkDragStart, column: string) {
        this.previousIndex = this.findIndexColumn(column);
    }
    dropListDropped(event: CdkDropList, column: string) {
        if (event) {
            moveItemInArray(this.availableColumns, this.previousIndex, this.findIndexColumn(column));
            this.applySelectedColumns();
        }
    }
    applySelectedColumns() {
        let _selectedColumns = this.selectedColumns.selected;
        this.selectedColumns = new SelectionModel<any>(true, this.availableColumns);
        for(let i = 0; i < this.availableColumns.length; i++){
            this.selectedColumns.toggle(this.availableColumns[i]);
            for( let j = 0; j < _selectedColumns.length; j++){
                if( this.availableColumns[i].name == _selectedColumns[j].name){
                    this.selectedColumns.toggle(this.availableColumns[i]);
                    break;
                }
            }
        }
        const _applySelectedColumns: string[] = [];
        this.selectedColumns.selected.forEach(col => { _applySelectedColumns.push(col.name) });
        this.displayedColumns = _applySelectedColumns;
    }
	/*----------------------------------------------------------------------- */
	
}